import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/en'
import VueMoment from 'vue-moment'

import AppStateMixin from './shared/appstate.js'

import AllSvg from './components/AllSvg'
import StatusBar from './components/StatusBar'
import ProgressBar from './components/ProgressBar'
import GreetingsMessage from './components/GreetingsMessage'
import InfoComponent from './components/InfoComponent'
import QuizComponent from './components/QuizComponent'
import LoginBoard from './components/LoginBoard'
import HeaderPart from './components/HeaderPart'
import ClubJoin from './components/ClubJoin'
import Pagination from './components/Pagination.vue'
import GolfProtection from './components/GolfProtection.vue'
import FacebookFriends from './components/FacebookFriends.vue'
import GolfProtectionForm from './components/GolfProtectionForm'
import AdminClubInfo from './components/AdminClubInfo.vue'
import SuccessComponent from './components/SuccessComponent'
// import GameLifes from './components/GameLifes.vue'
import Timer from './components/Timer.vue'
import QuizBoard from './components/QuizBoard.vue'
import TimerLoader from './components/TimerLoader.vue'
import LeaderBoardInfo from './components/LeaderboardInfo.vue'
import LeaderBoardShare from './components/LeaderboardShare.vue'
import Spinner from './components/Spinner.vue'

Vue.use(ElementUI)
locale.use(lang)
Vue.use(VueMoment)
Vue.mixin(AppStateMixin)

Vue.component(AllSvg.name, AllSvg)

Vue.component(StatusBar.name, StatusBar)
Vue.component(GreetingsMessage.name, GreetingsMessage)
Vue.component(InfoComponent.name, InfoComponent)
Vue.component(QuizComponent.name, QuizComponent)
Vue.component(ProgressBar.name, ProgressBar)
Vue.component(LoginBoard.name, LoginBoard)
Vue.component(HeaderPart.name, HeaderPart)
Vue.component(ClubJoin.name, ClubJoin)
Vue.component(SuccessComponent.name, SuccessComponent)
Vue.component(Pagination.name, Pagination)
Vue.component(GolfProtection.name, GolfProtection)
Vue.component(FacebookFriends.name, FacebookFriends)
Vue.component(GolfProtectionForm.name, GolfProtectionForm)
Vue.component(AdminClubInfo.name, AdminClubInfo)
// Vue.component(GameLifes.name, GameLifes)
Vue.component(Timer.name, Timer)
Vue.component(QuizBoard.name, QuizBoard)
Vue.component(TimerLoader.name, TimerLoader)
Vue.component(LeaderBoardInfo.name, LeaderBoardInfo)
Vue.component(LeaderBoardShare.name, LeaderBoardShare)
Vue.component(Spinner.name, Spinner)

Vue.config.productionTip = false

Vue.filter('timestamp', function (selectedTime) {
  let dateArray = Vue.moment.unix(parseInt(selectedTime)).format('YYYY-MM-DD').split('-')
  let frameArray = dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2]
  return frameArray
})

Vue.mixin({
  data() {
    return {
      get globalData() {
        // eslint-disable-next-line
        return DATA
      }
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
